// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 347 ? "SVG" : chunkId) + "." + {"29":"f3e5f1ed","181":"c5cf06dd","311":"f17bf40a","347":"55d52dc1","389":"1a7077a9","434":"d274e49a","487":"23ec593b","915":"cc1fad2f"}[chunkId] + ".chunk.js";
};